export default [
  {
    title: '',
    body: 'Me encanta RSS.com. Los he usado desde que comencé mi podcast hace 4 años. Estoy 1,000% de acuerdo en que tienen precios justos. <strong>De las 11 opciones que estaba considerando, ofrecían todo lo que estaba buscando.</strong> Lo que más me gusta de ellos es que no te cobran extra por cada función y constantemente lanzan nuevas actualizaciones en su software.',
    source: 'Reddit',
    user: 'u/famousashley',
    link: '',
    id: 1
  },
  {
    title: '',
    body: 'Estoy usando RSS.com y estoy muy feliz con la plataforma. <strong>No tiene límites en las horas de audio o episodios</strong>, lo cual es genial porque subo más de 3 horas de audio cada mes. Además, tiene funciones muy buenas con análisis avanzados.',
    source: 'Reddit',
    user: 'u/Temporary-Gap-2556',
    link: '',
    id: 2
  },
  {
    title: '',
    body: 'RSS.com es sólido, lo he estado usando durante un año. <strong>Cambié desde Podbean y no volvería atrás.</strong>',
    source: 'Reddit',
    user: 'u/zerofoxtrot93',
    link: '',
    id: 3
  },
  {
    title: '',
    body: 'RSS.com es genial. ¡Me encanta!<br/><br/><strong>Los análisis son increíbles.</strong> Muy útiles e informativos para hacer crecer un podcast.',
    source: 'Reddit',
    user: 'u/denethar',
    link: '',
    id: 4
  },
  {
    title: '',
    body: 'En 2022, busqué una plataforma para alojar mi podcast y <strong>terminé eligiendo RSS.com debido a su bajo precio, facilidad de uso y facilidad de distribución.</strong><br/><br/>Recientemente, también hicieron posible la distribución a través de YouTube, aunque yo lo hago por separado. Sin embargo, todo lo demás es administrado por RSS.com.<br/><br/>El único problema (aunque no es grave para mí) es que la página de análisis no se actualiza a diario y tiene cierto retraso en los datos. Aparte de eso, 5 estrellas.',
    source: 'Reddit',
    user: 'u/aemarques, Música & Som Podcast',
    link: '',
    id: 5
  },
  {
    title: 'Recientemente comencé mi podcast',
    body: 'Recientemente comencé mi aventura en el mundo del podcasting, y después de investigar varias plataformas de alojamiento, <strong>decidí elegir RSS.com, ¡y no podría estar más feliz con mi elección! Desde el principio, la plataforma ha sido increíblemente intuitiva y fácil de usar, lo que facilitó el proceso para un principiante como yo.</strong> Configurar mi podcast fue muy sencillo. La guía paso a paso me ayudó a crear mi feed RSS, enviar mi programa a los principales directorios como Apple Podcasts y Spotify, e incluso diseñar un sitio web profesional para mi podcast. El panel de análisis también es súper útil, ya que me brinda información clara sobre mi audiencia y el rendimiento de mis episodios.<br/><br/>Lo que realmente destaca de RSS.com es su servicio de atención al cliente. Cada vez que tuve una pregunta, su equipo respondió rápidamente y fue increíblemente servicial. Además, el precio es transparente y asequible, especialmente considerando el valor que ofrece. Si buscas una plataforma de alojamiento de podcasts confiable y fácil de usar que crezca contigo, recomiendo encarecidamente RSS.com. ¡Ha sido un cambio total en mi experiencia con los podcasts!',
    source: 'Trustpilot',
    user: 'Saeed Ahmed Agha',
    link: 'https://www.trustpilot.com/reviews/67b9c16cf0356aa1779b01ac',
    id: 6
  },
  {
    title: 'Todo',
    body: 'Todo, <strong>excelente experiencia de usuario, excelente interfaz</strong> y excelente servicio, rápido y confiable.',
    source: 'Trustpilot',
    user: 'Filip Volf',
    link: 'https://www.trustpilot.com/reviews/67b705e1b7d9182759f3c5a5',
    id: 7
  },
  {
    title: '¡Me sorprendió encontrar esto!',
    body: "Me sorprendió encontrar esto justo cuando NECESITABA una nueva plataforma de publicación, ya que la anterior dejó de ofrecer streaming para podcasts. Y descubrir que era tan fácil de usar y publicar fue simplemente la cereza del pastel. <strong>Mi técnico quedó asombrado de que pudiera crear el sitio en tan poco tiempo.</strong> Es un poco temprano para un 'veredicto' final, pero hasta ahora estoy impresionado.",
    source: 'Trustpilot',
    user: 'David Bowers',
    link: 'https://www.trustpilot.com/reviews/679d86379c03f6f29faedbf9',
    id: 8
  },
  {
    title: 'Hasta ahora, mi experiencia ha sido genial…',
    body: 'Mi experiencia ha sido increíble hasta ahora porque pensé que esto sería difícil, pero <strong>esta aplicación lo ha hecho súper fácil</strong> y útil. La ansiedad que solía sentir ha desaparecido, ¡gracias RSS!',
    source: 'Trustpilot',
    user: 'Toni Wise',
    link: 'https://www.trustpilot.com/reviews/67ab8d635e4291003d6607c6',
    id: 9
  },
  {
    title: 'RSS.com es el mejor amigo de un podcaster',
    body: 'Hace que sea <strong>MUY FÁCIL poner en marcha tu podcast</strong> sin pasos complicados. ¡Lo recomiendo especialmente para quienes son nuevos en el podcasting!',
    source: 'Trustpilot',
    user: 'Dr Andre Jerry',
    link: 'https://www.trustpilot.com/reviews/6797057f89f108d94cedce23',
    id: 10
  },
  {
    title: 'Simple y fácil de usar',
    body: '<strong>Los videos ofrecen una gran cantidad de información útil</strong>, especialmente para alguien que es completamente nuevo en el mundo del podcasting. ¡Gracias!',
    source: 'Trustpilot',
    user: 'Kristene Gulla',
    link: 'https://www.trustpilot.com/reviews/679d47786ac1f4dad021c2d8',
    id: 11
  },
  {
    title: 'Un recurso brillante',
    body: 'Extremadamente fácil de usar y útil. <br/>Soy un completo novato en todo lo relacionado con la informática. No entiendo la terminología, los procesos, básicamente no sé hacer nada más que escribir.<br/><br/>No puedo creerlo del todo, y aún no tengo pruebas, pero creo que logré grabar un audio en mi computadora portátil y luego, a través del sitio web de RSS, subirlo y publicar mi primer episodio. Si lo logré, fue completamente gracias a las instrucciones muy lógicas, bien explicadas y estructuradas en el sitio web. Incluso si no lo logré, me siento muy feliz en lugar de frustrado como suele suceder cuando fallo en algo nuevo. <strong>¡Siento que puedo seguir intentándolo! ¡Felicidades hasta ahora, RSS!</strong>',
    source: 'Trustpilot',
    user: 'Sally Ann Jackson',
    link: 'https://www.trustpilot.com/reviews/6775dc51d324ada81165b4b7',
    id: 12
  },
  {
    title: 'RSS lo ha hecho muy fácil',
    body: 'Siempre estuve nervioso por comenzar un podcast porque no sabía por dónde empezar a la hora de publicar un episodio. <strong>RSS lo ha hecho tan fácil que ojalá hubiera empezado antes.</strong>',
    source: 'Trustpilot',
    user: 'Alli Wilber',
    link: 'https://www.trustpilot.com/reviews/6779e57eb1843bd14be6e16f',
    id: 13
  },
  {
    title: 'Muy fácil de usar',
    body: 'Este es un servicio fantástico para podcasters. <strong>Es muy fácil de usar</strong> y estamos súper felices con esta plataforma.',
    source: 'Trustpilot',
    user: 'Telling Tinder Tales',
    link: 'https://www.trustpilot.com/reviews/6797dd9a52fd71127c2cca8b',
    id: 14
  },
  {
    title: 'Si eres nuevo en el podcasting, esta empresa es para ti',
    body: 'Debes probarlo. Fue rápido y fácil iniciar mi propio podcast, incluso con mi discapacidad visual. Pude ver todo en el sitio web sin la ayuda que normalmente uso al escribir en la computadora. <strong>Esta empresa hace que sea fácil para alguien sin habilidades profesionales comenzar su propio podcast.</strong>',
    source: 'Trustpilot',
    user: 'Minister Andrea Johnson',
    link: 'https://www.trustpilot.com/reviews/674aea0c455b87dbebec0c1d',
    id: 15
  },
  {
    title: 'El equipo de RSS siempre está…',
    body: '<strong>Las personas y el equipo de RSS siempre están tratando de estar un paso adelante de otras plataformas. ¡El servicio al cliente es excelente!</strong> Encuentran formas de hacer que sea más fácil para tu programa ser descubierto por el público. Llevo 5 años con la empresa y siempre han brindado un servicio excepcional.',
    source: 'Trustpilot',
    user: 'Broad St South',
    link: 'https://www.trustpilot.com/reviews/6747c051a49b562647c92b3f',
    id: 16
  },
  {
    title: 'Una gran plataforma para podcasters principiantes',
    body: '<strong>La plataforma de RSS.com es fácil de usar para principiantes.</strong> Subir y publicar el podcast toma solo unos minutos. Tan pronto como el episodio se publica, su URL está lista para compartir y la página web correspondiente está en línea. Es una experiencia muy agradable.',
    source: 'Trustpilot',
    user: 'Ying Zhou',
    link: 'https://www.trustpilot.com/reviews/6730e0dca3c39df26476167a',
    id: 17
  },
  {
    title: 'He usado RSS antes y cuando…',
    body: "He usado RSS antes, y cuando decidí iniciar otro podcast, investigué y pensé en probar uno de los anfitriones más 'populares'... mala idea. RSS es mucho más fácil y mucho más completo, especialmente en el área de distribución automática. Con los otros anfitriones que probé, había mucho más que hacer manualmente, incluyendo la necesidad de volver a configurar tu archivo de audio a otro formato, lo cual es un proceso que consume mucho tiempo y es muy frustrante. <strong>RSS es un soplo de aire fresco y el más fácil de todos… ¡y he probado tres de los 'top' hosts populares!</strong> Sin mencionar que aquí todo es ilimitado, mientras que los otros anfitriones son más caros y tienen muchas restricciones… ¡no RSS!",
    source: 'Trustpilot',
    user: 'John Alexander',
    link: 'https://www.trustpilot.com/reviews/670d7c17245bd6337814d7b5',
    id: 18
  },
  {
    title: 'Excelente servicio',
    body: 'Probé un par de servicios antes y <strong>RSS.com tiene una de las mejores relaciones calidad-precio del mercado.</strong> La interfaz también es extremadamente amigable para usuarios principiantes y hace que comenzar sea muy sencillo.',
    source: 'Trustpilot',
    user: 'Devon & Jonathan Grey',
    link: 'https://www.trustpilot.com/reviews/6734f6a11179b8de3c5c3de7',
    id: 19
  },
  {
    title: 'Me encanta mi experiencia con RSS',
    body: 'Me encanta mi experiencia publicando mi primer podcast. Fue simple y directo, y me permite editar un número ilimitado de veces antes de publicarlo. <strong>Me gusta que me dé la opción de agregar transcripciones automáticamente o de forma manual, además de dividir en capítulos si es necesario.</strong>',
    source: 'Trustpilot',
    user: 'Jiaxin Li',
    link: 'https://www.trustpilot.com/reviews/66f9e045b55c41e604372bb6',
    id: 20
  },
  {
    title: 'Fácil de usar',
    body: 'Fácil de usar, rápido y muy eficiente para subir archivos.',
    source: 'Trustpilot',
    user: 'Leona',
    link: 'https://www.trustpilot.com/reviews/67b2ad4be775315f2632a970',
    id: 21
  },
  {
    title: '¡Wow!!!!!',
    body: '<strong>¡Tan fácil! ¿Por qué no hice esto antes?!???</strong><br/><br/>Gran experiencia y ahora voy a publicar muchos más episodios!!!!',
    source: 'Trustpilot',
    user: 'Nick Materese',
    link: 'https://www.trustpilot.com/users/67675527765b7a220231a316',
    id: 22
  },
  {
    title: 'Todos deberían suscribirse',
    body: 'He estado con RSS durante los últimos 3 años y es una plataforma muy fácil de navegar que hace que tu contenido de audio sea lo más visible posible. Mi empresa ha crecido con oyentes de todo el mundo gracias al nivel de profesionalismo que RSS.com ofrece a los creadores. <strong>Todos deberían suscribirse a RSS.com.</strong>',
    source: 'Trustpilot',
    user: 'Broad St South',
    link: 'https://www.trustpilot.com/reviews/6693ea921e131e4058b363e0',
    id: 23
  },
  {
    title: 'Genial para principiantes',
    body: 'Muy fácil de usar y amigable para principiantes. Muy profesional. Sin trampas ni costos ocultos. Me encanta. <strong>Estoy feliz de haber elegido esta plataforma en lugar de otras opciones de alojamiento de podcasts.</strong> Me encantan los tutoriales y guías sobre cómo iniciar y hacer crecer tu podcast con éxito.',
    source: 'Trustpilot',
    user: 'Zinhle Bhembe',
    link: 'https://www.trustpilot.com/reviews/666c8a555f248d8e402e6f9e',
    id: 24
  },
  {
    title: '¡Brillante, gracias!',
    body: 'Comencé esto de manera espontánea para que mis clientes pudieran escucharme en lugar de tener que sentarse a ver un video, ¡y fue tan fácil! ¡Gracias! <strong>Grabé, subí y publiqué un podcast de 30 minutos en menos de una hora.</strong> ¡Increíble!',
    source: 'Trustpilot',
    user: 'Anna Martin',
    link: 'https://www.trustpilot.com/reviews/674054e5404fbaae63e03d42',
    id: 25
  },
  {
    title: '¡Tan fácil como 1, 2, 3!',
    body: '<strong>Muy fácil de usar y seguir.</strong> Soy un profesional en producción de medios, pero esta es la primera vez que lo hago solo, así que es reconfortante saber que RSS realmente me respalda en cuanto a la distribución de mi contenido.',
    source: 'Trustpilot',
    user: 'Michelle Langthorne',
    link: 'https://www.trustpilot.com/reviews/665b33ddb1cddf62a44f6666',
    id: 26
  },
  {
    title: 'Usar RSS ha sido la parte más fácil de…',
    body: 'Usar RSS ha sido la parte más fácil de crear este podcast. <strong>Las instrucciones son claras, la interfaz es limpia y los resultados son inmediatos.</strong> ¡Gracias, RSS!',
    source: 'Trustpilot',
    user: 'Mary Barbara Hanna',
    link: 'https://www.trustpilot.com/reviews/6737517feb551c5d6dcd0cf1',
    id: 27
  },
  {
    title: 'Estoy tan feliz',
    body: 'Estoy tan feliz. <strong>Acabo de crear mi primer podcast en RSS en menos de 5 minutos.</strong> Sin embargo, aún tengo mucho que aprender. Solo lo intenté por primera vez.<br/><br/>Gracias, RSS.',
    source: 'Trustpilot',
    user: 'Puru Thapa',
    link: 'https://www.trustpilot.com/reviews/67870b17fab25d0d26db70e6',
    id: 28
  },
  {
    title: '¡Fue pan comido!',
    body: 'Publicar mi primer episodio fue pan comido. <strong>Rara vez es tan fácil tomar una idea y convertirla en un producto tangible, pero en este caso fue tan fácil como 3.14.</strong> ¡Mi podcast, NI vs. AI, ya está disponible! ¡Qué emocionante! Gracias, RSS.com. Estoy deseando explorar más funciones.',
    source: 'Trustpilot',
    user: 'Customer (no name given)',
    link: 'https://www.trustpilot.com/reviews/66d7319d9c8ccdf46fe57eca',
    id: 29
  },
  {
    title: '¡Fue tan fácil!',
    body: '¡¡¡Fue tan fácil!!! Me impresionaron las reseñas sobre la plataforma RSS.com, así que decidí explorarla. <strong>¡Estoy muy feliz de lo bien que está funcionando todo!</strong>',
    source: 'Trustpilot',
    user: 'Alberto Rocha',
    link: 'https://www.trustpilot.com/reviews/677f736d9d9a5a52d7f73fb8',
    id: 30
  },
  {
    title: '¡Excelente plataforma para podcasters!',
    body: 'He estado usando RSS.com para alojar mi podcast y ha sido una experiencia excelente hasta ahora. La plataforma es fácil de usar y ofrece todas las herramientas esenciales para subir y gestionar episodios sin problemas. <strong>La función de análisis es particularmente útil para comprender mejor a mi audiencia.</strong> Además, el equipo de soporte es muy receptivo y siempre está listo para ayudar con cualquier consulta. <strong>Recomiendo encarecidamente RSS.com</strong> tanto a podcasters nuevos como experimentados que busquen un servicio de alojamiento confiable.',
    source: 'Trustpilot',
    user: 'Dïänä Jin',
    link: 'https://www.trustpilot.com/reviews/66aaeea83468df8990dffbba',
    id: 31
  },
  {
    title: '¡Una manera fantástica para que los principiantes comiencen!',
    body: '¡Una forma fantástica para que los principiantes comiencen un podcast!',
    source: 'Trustpilot',
    user: 'Heavenly Minded Academy',
    link: 'https://www.trustpilot.com/reviews/6798eb9610a0a1d93ef2cc3c',
    id: 32
  },
  {
    title: 'Facilidad para editar en pantalla o en…',
    body: '<strong>La facilidad para editar en la pantalla o en el teléfono es increíble</strong>, y el precio de la versión de pago es justo.',
    source: 'Trustpilot',
    user: 'Onshalique Wilson',
    link: 'https://www.trustpilot.com/reviews/677fdf3cd7fd877acb4cda98',
    id: 33
  },
  {
    title: 'Tuve problemas con otras plataformas…',
    body: 'Tuve problemas con otras plataformas, pero ninguna ofrece ni la mitad de lo que ofrece RSS.com.<br/><br/><strong>Es fácil de usar y publicar es muy sencillo.</strong> Estoy deseando publicar muchos más episodios muy pronto.',
    source: 'Trustpilot',
    user: 'John',
    link: 'https://www.trustpilot.com/reviews/66806eaafced63b6f7896465',
    id: 34
  },
  {
    title: '¡Increíble!',
    body: '<strong>Todo es muy simple, fácil de usar, con precios razonables</strong> y perfecto para crear y alojar tu podcast en RSS. ¡Lo recomiendo altamente!',
    source: 'Trustpilot',
    user: 'Delilah Beau',
    link: 'https://www.trustpilot.com/reviews/664433ee49efab8edddc4d63',
    id: 35
  },
  {
    title: 'Tengo dos podcasts en alemán alojados en…',
    body: 'Tengo dos podcasts en alemán alojados en RSS.com y <strong>es simple y fácil de usar.</strong><br/><br/>No tengo ninguna queja.',
    source: 'Trustpilot',
    user: 'Patrick',
    link: 'https://www.trustpilot.com/reviews/677bdd143f0a3a67f71d2bf1',
    id: 36
  },
  {
    title: 'Tan fácil como 1-2-3',
    body: 'Soy completamente nuevo en la creación de contenido en general, y mucho más en el mundo del podcasting. <strong>RSS ha hecho que esto sea tan fácil como 1-2-3.</strong>',
    source: 'Trustpilot',
    user: 'tinns',
    link: 'https://www.trustpilot.com/reviews/666d18edef50fd91a57b2aab',
    id: 37
  },
  {
    title: '¡Acabo de subir mi primer podcast!',
    body: 'Acabo de terminar de subir mi primer podcast y <strong>RSS.com ha hecho que sea muy fácil para mí comenzar.</strong> Después de pasar muchas horas en las últimas dos semanas, encontré todo lo que necesitaba aquí, explicado en términos sencillos para empezar rápido. ¡WOW! ¡Me encanta usar RSS.com desde ya!',
    source: 'Trustpilot',
    user: 'Terry Jarrell',
    link: 'https://www.trustpilot.com/reviews/667fa2d76f2cdee28b728560',
    id: 38
  },
  {
    title: 'Fácil, increíble y divertido',
    body: 'Fácil, increíble y divertido.<br/><br/>Expresar tus ideas al mundo fue fácil. En lugar de dejarlas acumulando polvo en la app de notas de voz, ¡dales la oportunidad de cobrar vida y que el mundo las escuche!',
    source: 'Trustpilot',
    user: 'Maria Abdel Rahman',
    link: 'https://www.trustpilot.com/reviews/6681dd04dc411e9e004ef40b',
    id: 39
  },
  {
    title: 'He estado buscando en sitios web todo el día…',
    body: 'He estado buscando en sitios web todo el día hasta que encontré este, que me permitió hacer mi podcast con facilidad.',
    source: 'Trustpilot',
    user: 'Bantaboyz Z&L',
    link: 'https://www.trustpilot.com/reviews/66716a79b9ef13d512faef82',
    id: 40
  },
  {
    title: '¡Este proceso fue muy fácil!',
    body: '<strong>Este proceso fue muy fácil,</strong> durante meses lo había estado sobrepensando y finalmente lo hice. Desde el inicio hasta el final no me tomó más de 15 minutos.',
    source: 'Trustpilot',
    user: 'Maritza',
    link: 'https://www.trustpilot.com/reviews/668698bc3c268accee41dfac',
    id: 41
  },
  {
    title: 'El proceso',
    body: '<strong>El proceso fue sencillo</strong> y estoy emocionado de que la gente pueda beneficiarse de los episodios. ¡Gracias!',
    source: 'Trustpilot',
    user: 'Dr. Reginald Woods',
    link: 'https://www.trustpilot.com/reviews/66fdf90d48e3c73b4371f0bc',
    id: 42
  },
  {
    title: '¡Gran soporte!',
    body: '¡Soporte! Ana... ¡fenomenal! Me guió a través del proceso después de que cometí un error. ¡Increíble! ¡Fácil de hacer!',
    source: 'Trustpilot',
    user: 'Billy Burke',
    link: 'https://www.trustpilot.com/reviews/666887b96b313d48cb77456a',
    id: 43
  },
  {
    title: '¡Gracias RSS.com!',
    body: 'Intenté comenzar en YouTube y Spotify, pero <strong>RSS.com es mucho más fácil para los principiantes.</strong>',
    source: 'Trustpilot',
    user: 'Noel Hoines',
    link: 'https://www.trustpilot.com/reviews/666ad6f406ff1c80ae59de1c',
    id: 44
  },
  {
    title: 'Emocionado con la herramienta de podcast de RSS.com',
    body: 'La experiencia ha sido excelente al llevar Radio Fortune Africa al siguiente nivel. ¡Una bendición real!',
    source: 'Trustpilot',
    user: 'Cantona Joseph',
    link: 'https://www.trustpilot.com/reviews/66e812bcd2be99d1b9e8bc35',
    id: 45
  },
  {
    title: 'Crear y publicar un podcast nunca ha sido tan fácil',
    body: 'Crear y publicar un podcast nunca ha sido tan fácil, <strong>te proporcionan todo lo que necesitas sin esfuerzo y en cinco minutos tu podcast está en internet.</strong> Y lo mejor de todo, tienes un mes gratis. Sin duda, es el mejor servicio que he recibido hasta ahora.',
    source: 'Trustpilot',
    user: 'ilias ro',
    link: 'https://www.trustpilot.com/reviews/66d0850642bd80a9974a9c8a',
    id: 46
  },
  {
    title: '¡Un gran descubrimiento!',
    body: 'Calidad y facilidad aseguradas. Es simple. Gráficos atractivos. Bien explicado. ALTA CALIDAD. FÁCIL DE USAR × ¡MUY ÚTIL!',
    source: 'Trustpilot',
    user: "Taveau D'Arcy",
    link: 'https://www.trustpilot.com/reviews/667d9b8002e1c964db82dd9c',
    id: 47
  },
  {
    title: 'El soporte general y la facilidad de uso',
    body: '¡Muchas gracias por toda su ayuda y apoyo!',
    source: 'Trustpilot',
    user: 'Susan Post',
    link: 'https://www.trustpilot.com/reviews/6795ad71320b2becdafb401d',
    id: 48
  },
  {
    title: 'La simplicidad por sí sola',
    body: 'La simplicidad por sí sola ofrece un acceso sin igual en comparación con otras plataformas.',
    source: 'Trustpilot',
    user: 'City Grant',
    link: 'https://www.trustpilot.com/reviews/674213cec5951cf7dcf4818e',
    id: 49
  },
  {
    title: '¡Muy fácil para una persona con poca habilidad tecnológica!',
    body: '<strong>Fue súper fácil.</strong> No necesité que mis hijos me ayudaran, ¡lo cual dice mucho!',
    source: 'Trustpilot',
    user: 'D Renee Neal',
    link: 'https://www.trustpilot.com/reviews/67369a087d805e406bfbd89c',
    id: 50
  },
  {
    title: '¡Lo hizo tan simple para publicar mi primer…!',
    body: '<strong>Hizo que publicar mi primer episodio de podcast fuera muy fácil.</strong> Gracias por mantener la tecnología sencilla.',
    source: 'Trustpilot',
    user: 'Angie Engstrom',
    link: 'https://www.trustpilot.com/reviews/664e110b319791c31fd628f7',
    id: 51
  },
  {
    title: 'Muy fácil de usar',
    body: 'Muy fácil de usar, directo y con instrucciones fáciles de entender.',
    source: 'Trustpilot',
    user: 'Paige Retchko',
    link: 'https://www.trustpilot.com/reviews/66b541d35fb3cf321f58564f',
    id: 52
  },
  {
    title: 'Muy fácil y directo de usar',
    body: 'Muy fácil y directo de usar. No podría haber pedido una configuración más sencilla.',
    source: 'Trustpilot',
    user: 'Joel Fortune',
    link: 'https://www.trustpilot.com/reviews/6701ecd0b454e3c883c151b7',
    id: 53
  },
  {
    title: '¡RSS es increíble!',
    body: '¡RSS es increíble! <strong>Fácil, directo, servicio 10/10.</strong>',
    source: 'Trustpilot',
    user: 'Andrew George',
    link: 'https://www.trustpilot.com/reviews/67632d5181d2f39815a41b43',
    id: 54
  },
  {
    title: 'Fácil de usar, ¡gracias!',
    body: 'Este sitio web hizo que fuera muy fácil comenzar. ¡Gracias!',
    source: 'Trustpilot',
    user: 'Jack Cunningham',
    link: 'https://www.trustpilot.com/reviews/67439443c6f9f56a6a9be7ab',
    id: 55
  },
  {
    title: '',
    body: 'Tuve una experiencia excelente con esta plataforma. <strong>Fue muy fácil de usar,</strong> con una interfaz intuitiva que me permitió navegar sin problemas. Encontré lo que necesitaba rápidamente y todo funcionó a la perfección. <strong>Sin duda, la recomendaría a otros.</strong> ¡Gran trabajo!',
    source: 'Reviews.io',
    user: 'Cliente',
    link: 'https://www.reviews.io/company-review/store/rss-com/24825854',
    id: 56
  },
  {
    title: '',
    body: '<strong>Precios razonables y navegación sencilla,</strong> ¿qué más se puede pedir?',
    source: 'Reviews.io',
    user: 'Cliente',
    link: 'https://www.reviews.io/company-review/store/rss-com/24775309',
    id: 57
  },
  {
    title: '',
    body: 'Configuré un perfil y todo para mi podcast después de escuchar sobre este programa hoy. Ha sido la parte más sencilla de todo el proceso.',
    source: 'Reviews.io',
    user: 'Cliente',
    link: 'https://www.reviews.io/company-review/store/rss-com/24516463',
    id: 58
  },
  {
    title: '',
    body: 'Es la primera vez que hago un podcast para un trabajo escolar y <strong>RSS lo hizo súper fácil</strong> y sencillo. Me tomó, como máximo, cinco minutos desde la creación de mi cuenta hasta la publicación de mi podcast. Súper agradable y simple para principiantes.',
    source: 'Reviews.io',
    user: 'Cliente',
    link: 'https://www.reviews.io/company-review/store/rss-com/24391603',
    id: 59
  },
  {
    title: '',
    body: 'RSS.com es una excelente plataforma para comenzar y administrar un podcast. <strong>Su interfaz fácil de usar facilita la carga de episodios, el seguimiento de estadísticas y la distribución del contenido en las principales plataformas.</strong> Los precios son asequibles y el servicio de atención al cliente es excepcional. Para los podcasters que buscan compartir contenido sin complicaciones, RSS.com es una opción fantástica. Consulta https://menupricesdutchbros.com/ para inspirarte en la creación de contenido de nicho.',
    source: 'Reviews.io',
    user: 'Cliente',
    link: 'https://www.reviews.io/company-review/store/rss-com/24377327',
    id: 60
  },
  {
    title: '',
    body: 'RSS.com es una plataforma de alojamiento de podcasts fácil de usar que ofrece almacenamiento de audio ilimitado, gestión sencilla de episodios y distribución automática a directorios principales como Apple Podcasts y Spotify. <strong>También cuenta con análisis detallados y múltiples opciones de monetización,</strong> lo que la convierte en una excelente opción tanto para nuevos como para experimentados podcasters que buscan soluciones completas para sus podcasts.',
    source: 'Reviews.io',
    user: 'Cliente',
    link: 'https://www.reviews.io/company-review/store/rss-com/24329503',
    id: 61
  },
  {
    title: '',
    body: 'Me impresionó mucho mi primera experiencia con RSS.com para comenzar mi aventura en el mundo del podcasting. La interfaz de la plataforma es intuitiva y fácil de usar, lo que hizo que todo el proceso fuera fluido y sin complicaciones, incluso para un principiante como yo.<br/><br/><strong>Un gran punto a favor es la distribución automática a plataformas como Spotify, Apple Podcasts y Google Podcasts, lo que me ahorró mucho tiempo y esfuerzo.</strong> Las herramientas de análisis también son fantásticas: claras, detalladas e increíblemente útiles para seguir el rendimiento y el crecimiento de mi podcast.<br/><br/>También me encanta el precio asequible y las funciones ilimitadas, como el almacenamiento y la cantidad de episodios. Es la elección perfecta para cualquiera que quiera centrarse en crear contenido de calidad sin preocuparse por las limitaciones técnicas.<br/><br/>Si estás buscando una plataforma de podcasting profesional, fácil de usar y confiable, estoy seguro de que RSS.com superará tus expectativas.',
    source: 'Reviews.io',
    user: 'Cliente',
    link: 'https://www.reviews.io/company-review/store/rss-com/24267263',
    id: 62
  },
  {
    title: '',
    body: '<strong>Proceso súper fácil,</strong> con excelentes videos en YouTube para guiarme. 10/10, lo recomendaría.',
    source: 'Reviews.io',
    user: 'Cliente',
    link: 'https://www.reviews.io/company-review/store/rss-com/24168321',
    id: 63
  },
  {
    title: '',
    body: 'Estoy muy agradecido con RSS.com. Es la primera vez que hago un podcast, y <strong>RSS.com lo hizo muy fácil.</strong> ¡Muchas gracias, gente amable!',
    source: 'Reviews.io',
    user: 'Cliente',
    link: 'https://www.reviews.io/company-review/store/rss-com/23878139',
    id: 64
  },
  {
    title: '',
    body: 'Es <strong>fácil para principiantes y carga rápidamente.</strong> Estoy impresionado con la plataforma hasta ahora. ¡Espero con ansias el futuro!',
    source: 'Reviews.io',
    user: 'Cliente',
    link: 'https://www.reviews.io/company-review/store/rss-com/23854575',
    id: 65
  },
  {
    title: '',
    body: '<strong>Muy fácil e intuitivo.</strong> Es tan simple que pude hacerlo sin problemas.',
    source: 'Reviews.io',
    user: 'Cliente',
    link: 'https://www.reviews.io/company-review/store/rss-com/23459064',
    id: 66
  },
  {
    title: '',
    body: 'Un buen lugar para poner en marcha un podcast. <strong>Muy fácil de usar.</strong> Te guía en cada paso del proceso. ¡Incluso un mono podría publicar un podcast!',
    source: 'Reviews.io',
    user: 'Cliente',
    link: 'https://www.reviews.io/company-review/store/rss-com/23363534',
    id: 67
  },
  {
    title: '',
    body: 'Rápido y <strong>extremadamente fácil de usar</strong> con una guía paso a paso del increíble equipo.',
    source: 'Reviews.io',
    user: 'Cliente',
    link: 'https://www.reviews.io/company-review/store/rss-com/23316585',
    id: 68
  },
  {
    title: '',
    body: '<strong>Gran interfaz, muy fácil de usar.</strong> Lo que parecía confuso en otras plataformas aquí fue muy sencillo y motivador.',
    source: 'Reviews.io',
    user: 'Cliente',
    link: 'https://www.reviews.io/company-review/store/rss-com/22942303',
    id: 69
  },
  {
    title: '',
    body: '<strong>Una gran solución que ayuda a ahorrar tiempo</strong> y a dar visibilidad a nuestro podcast!<br/><br/>– Incluyó una imagen del arte de su podcast – Wellbeing ignites Welldoing con Adwoa K. Buahene',
    source: 'Reviews.io',
    user: 'Cliente',
    link: 'https://www.reviews.io/company-review/store/rss-com/22767107',
    id: 70
  },
  {
    title: '',
    body: 'Cuando Spotify for Podcasters integró completamente su nueva plataforma de alojamiento, TODO cambió: la función de grabación y edición, que antes era fluida, desapareció (y si no tenías cuidado, podías perder todos tus episodios de podcast… *tos* me *tos*). <strong>RSS es, sin duda, un salvavidas para continuar con mi podcast.</strong> Probé tres otras plataformas de alojamiento y ninguna fue tan fluida ni rápida. ¡RSS es una opción increíble para todos, GRACIAS RSS!',
    source: 'Reviews.io',
    user: 'Cliente',
    link: 'https://www.reviews.io/company-review/store/rss-com/22598681',
    id: 71
  },
  {
    title: '',
    body: '¡RSS.com es fantástico! Lanzar nuestro podcast, "Dakdekker Amersfoort", fue súper fácil. <strong>Gran soporte y excelentes análisis.</strong> ¡Altamente recomendado!',
    source: 'Reviews.io',
    user: 'Cliente',
    link: 'https://www.reviews.io/company-review/store/rss-com/22511997',
    id: 72
  },
  {
    title: '',
    body: 'Es mi primera vez aquí y la experiencia ha sido absolutamente increíble porque es muy fácil de usar. Soy un podcaster novato que lo está haciendo todo solo en este momento, así que <strong>el acceso y la información son MUY útiles.</strong> ¡No puedo esperar a ver cómo evoluciona esto! ¡Gracias!',
    source: 'Reviews.io',
    user: 'Cliente',
    link: 'https://www.reviews.io/company-review/store/rss-com/22349023',
    id: 73
  },
  {
    title: '',
    body: 'Fácil de configurar y comenzar.',
    source: 'Facebook',
    user: 'Mike Jonjak',
    link: '',
    id: 74
  },
  {
    title: '',
    body: '<strong>¡Me encanta este servicio!</strong> Llevaba tiempo queriendo empezar un podcast sobre marketing de afiliados. No lo hacía porque no sabía cómo alojarlo y distribuirlo. Pero luego empezamos a trabajar con RSS y fue tan fácil. <strong>Me llevó más tiempo escribir la descripción de mi podcast que configurarlo todo.</strong> ¡Era tan fácil que no estaba seguro de haberlo hecho bien, pero lo hice! Me encanta y hace que empezar sea muy sencillo. Lo recomiendo totalmente.',
    source: 'Facebook',
    user: 'Jamie Birch',
    link: '',
    id: 75
  }
]
